import type { Session, Subscription, User } from '@supabase/supabase-js';

import { getSupabaseClient, type DdmSupabaseClient } from './supabase';

export async function getSession(
  client: DdmSupabaseClient = getSupabaseClient(),
): Promise<Session | null> {
  const { data, error } = await client.auth.getSession();
  if (error) throw error;
  return data.session;
}

export async function getUser(
  client: DdmSupabaseClient = getSupabaseClient(),
): Promise<User | null> {
  const { data, error } = await client.auth.getUser();
  if (error) {
    // Anon callers raise AuthSessionMissingError — surface as null user.
    if (error.name === 'AuthSessionMissingError') return null;
    throw error;
  }
  return data.user;
}

export type AuthChangeHandler = (session: Session | null) => void;

export function onAuthStateChange(
  handler: AuthChangeHandler,
  client: DdmSupabaseClient = getSupabaseClient(),
): Subscription {
  const { data } = client.auth.onAuthStateChange((_event, session) => handler(session));
  return data.subscription;
}

export async function signOut(client: DdmSupabaseClient = getSupabaseClient()): Promise<void> {
  const { error } = await client.auth.signOut();
  if (error) throw error;
}
